import IconUserManagement from '../../images/IconUserManagement';
import IconContact from '../../images/IconContact';
import IconCalendar from '../../images/IconCalendar';
import IconTicket from '../../images/IconTicket';
import IconOrganize from '../../images/IconOrganize';
import IconGlobe from '../../images/IconGlobe.jsx';
import {
    PERMISSION_CALENDAR,
    PERMISSION_CONTACTS,
    PERMISSION_FILES,
    PERMISSION_LEADS,
    PERMISSION_OWNED_ORGANIZATIONS,
    PERMISSION_PARTNER_ORGANIZATIONS,
    PERMISSION_PROJECTS,
    PERMISSION_ROLES,
    PERMISSION_TICKETS_ADMIN,
    PERMISSION_TICKETS_USER,
    PERMISSION_USERS
} from '../../../utils/constants';
import IconFiles from '../../images/IconFiles.jsx';
import IconRocket from '../../images/IconRocket.jsx';
import IconBulb from '../../images/IconBulb.jsx';
import IconAi from '../../images/IconAi.jsx';
import React from 'react';

export const menuList = [
    {
        category: 'Personal Assistant',
        icon: <IconAi className='stroke-theme1-white w-[24px] h-[24px]' />,
        links: [
            {
                label: 'New chat',
                to: '/personal-assistant',
                public: true
            },
            {
                label: 'History',
                to: '/personal-assistant-history',
                public: true
            }
        ]
    },
    {
        category: 'Global view',
        icon: <IconGlobe className='fill-theme1-white w-5 h-5 mr-[2px]' />,
        links: [
            {
                label: 'Global view',
                to: '/global-view',
                public: true
            },
            {
                label: 'Advanced Search',
                to: '/global-view/advanced-search',
                public: true
            }
        ]
    },
    {
        category: 'Leads',
        icon: <IconBulb className='stroke-theme1-white w-[24px] h-[24px]' />,
        links: [
            {
                label: 'Leads List',
                to: '/leads',
                permission: PERMISSION_LEADS,
                actions: ['read']
            }
        ]
    },
    {
        category: 'Calendar',
        icon: <IconCalendar className='stroke-theme1-white w-[24px] h-[24px]' />,
        links: [
            {
                label: 'View calendar',
                to: '/calendar',
                permission: PERMISSION_CALENDAR,
                actions: ['read']
            },
            {
                label: 'Add new meeting',
                to: '/calendar/add',
                permission: PERMISSION_CALENDAR,
                actions: ['create']
            }
        ]
    },
    {
        category: 'My Network',
        icon: <IconContact className='stroke-theme1-white w-[26px] h-[24px]' />,
        links: [
            {
                label: 'Dashboard',
                to: '/contacts',
                permission: PERMISSION_CONTACTS,
                actions: ['read']
            },
            {
                label: 'Contacts',
                to: '/contacts/list',
                permission: PERMISSION_CONTACTS,
                actions: ['read']
            },
            {
                label: 'Add new contact',
                to: '/contacts/add',
                permission: PERMISSION_CONTACTS,
                actions: ['create']
            },
            {
                label: 'Import contacts',
                to: '/contacts/import',
                permission: PERMISSION_CONTACTS,
                actions: ['create']
            },
            {
                label: 'Contact duplicates',
                to: '/contacts/duplicates',
                permission: PERMISSION_CONTACTS,
                actions: ['read']
            }
        ]
    },

    {
        category: 'Organizations',
        icon: <IconOrganize className='stroke-theme1-white w-[24px] h-[24px]' />,
        links: [
            {
                label: 'Dashboard',
                to: '/organizations',
                permission: [PERMISSION_PARTNER_ORGANIZATIONS, PERMISSION_OWNED_ORGANIZATIONS],
                actions: ['read']
            },
            {
                label: 'Organizations',
                to: '/organizations/list',
                permission: [PERMISSION_PARTNER_ORGANIZATIONS, PERMISSION_OWNED_ORGANIZATIONS],
                actions: ['read']
            },
            {
                label: 'Add new organization',
                to: '/organizations/add',
                permission: [PERMISSION_PARTNER_ORGANIZATIONS, PERMISSION_OWNED_ORGANIZATIONS],
                actions: ['create']
            }
        ]
    },
    {
        category: 'Projects',
        icon: <IconRocket className='stroke-theme1-white w-[24px] h-[24px]' />,
        links: [
            {
                label: 'Projects',
                to: '/projects',
                permission: [PERMISSION_PROJECTS],
                actions: ['read']
            },
            {
                label: 'Add new project',
                to: '/projects/add',
                permission: [PERMISSION_PROJECTS],
                actions: ['create']
            }
        ]
    },
    {
        category: 'Files',
        icon: <IconFiles className='stroke-theme1-white w-[24px] h-[24px]' />,
        links: [
            {
                label: 'Files Dashboard',
                to: '/files',
                permission: [PERMISSION_FILES],
                actions: ['read']
            },
            {
                label: 'Add new files',
                to: '/files/import',
                permission: [PERMISSION_FILES],
                actions: ['create']
            }
        ]
    },
    {
        category: 'Support Center',
        icon: <IconTicket className='stroke-theme1-white w-[26px] h-[22px]' />,
        links: [
            {
                label: 'My tickets',
                to: '/my-tickets',
                permission: PERMISSION_TICKETS_USER,
                actions: ['read']
            },
            {
                label: 'Tickets management',
                to: '/tickets',
                permission: PERMISSION_TICKETS_ADMIN,
                actions: ['read']
            }
        ]
    },
    {
        category: 'Users Management',
        icon: <IconUserManagement className='stroke-theme1-white w-[26px]' />,
        links: [
            {
                label: 'Users',
                to: '/users',
                permission: PERMISSION_USERS,
                actions: ['read']
            },
            {
                label: 'Roles',
                to: '/roles',
                permission: PERMISSION_ROLES,
                actions: ['read']
            }
        ]
    }
];
